/**
 * Manifest of the downloadable logo files under
 * frontend/public/brand-assets/logo/ — mirrors the Google Drive folder
 * "Graphic Assets/LOGO/Logo" minus working files (.ai, .psd) and the
 * loose 2022 files, dropped on Doreen's request (Sep 24, 2026).
 *
 * GENERATED — do not hand-edit. When files are added or replaced in
 * public/brand-assets/logo, regenerate this list (a small script walking
 * the folder; see MOSY_CONTEXT.md 2026-09-24 "Brand kit: logos").
 */
export interface LogoFile { ext: string; url: string; size: number; name: string }
export interface LogoVariant { variant: string; files: LogoFile[] }
export interface LogoGroup { folder: string; sub: string; variants: LogoVariant[] }

export const LOGO_GROUPS: LogoGroup[] = [
  {
    "folder": "HD_Print",
    "sub": "FullLogo",
    "variants": [
      {
        "variant": "Black",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/FullLogo/LampTwist_FullLogo_Black_HD.eps",
            "size": 407786,
            "name": "LampTwist_FullLogo_Black_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/FullLogo/LampTwist_FullLogo_Black_HD.pdf",
            "size": 66000,
            "name": "LampTwist_FullLogo_Black_HD.pdf"
          }
        ]
      },
      {
        "variant": "FullColor",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/FullLogo/LampTwist_FullLogo_FullColor_HD.eps",
            "size": 409454,
            "name": "LampTwist_FullLogo_FullColor_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/FullLogo/LampTwist_FullLogo_FullColor_HD.pdf",
            "size": 65125,
            "name": "LampTwist_FullLogo_FullColor_HD.pdf"
          }
        ]
      },
      {
        "variant": "Green",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/FullLogo/LampTwist_FullLogo_Green_HD.eps",
            "size": 407710,
            "name": "LampTwist_FullLogo_Green_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/FullLogo/LampTwist_FullLogo_Green_HD.pdf",
            "size": 66099,
            "name": "LampTwist_FullLogo_Green_HD.pdf"
          }
        ]
      },
      {
        "variant": "White",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/FullLogo/LampTwist_FullLogo_White_HD.eps",
            "size": 402426,
            "name": "LampTwist_FullLogo_White_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/FullLogo/LampTwist_FullLogo_White_HD.pdf",
            "size": 61158,
            "name": "LampTwist_FullLogo_White_HD.pdf"
          }
        ]
      }
    ]
  },
  {
    "folder": "HD_Print",
    "sub": "Icon",
    "variants": [
      {
        "variant": "Black",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/Icon/LampTwist_Icon_Black_HD.eps",
            "size": 3999054,
            "name": "LampTwist_Icon_Black_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/Icon/LampTwist_Icon_Black_HD.pdf",
            "size": 368020,
            "name": "LampTwist_Icon_Black_HD.pdf"
          }
        ]
      },
      {
        "variant": "Green",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/Icon/LampTwist_Icon_Green_HD.eps",
            "size": 4000630,
            "name": "LampTwist_Icon_Green_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/Icon/LampTwist_Icon_Green_HD.pdf",
            "size": 367166,
            "name": "LampTwist_Icon_Green_HD.pdf"
          }
        ]
      },
      {
        "variant": "White",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/Icon/LampTwist_Icon_White_HD.eps",
            "size": 3986942,
            "name": "LampTwist_Icon_White_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/Icon/LampTwist_Icon_White_HD.pdf",
            "size": 354901,
            "name": "LampTwist_Icon_White_HD.pdf"
          }
        ]
      },
      {
        "variant": "Yellow",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/Icon/LampTwist_Icon_Yellow_HD.eps",
            "size": 4032034,
            "name": "LampTwist_Icon_Yellow_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/Icon/LampTwist_Icon_Yellow_HD.pdf",
            "size": 368916,
            "name": "LampTwist_Icon_Yellow_HD.pdf"
          }
        ]
      }
    ]
  },
  {
    "folder": "HD_Print",
    "sub": "Icon_Outline",
    "variants": [
      {
        "variant": "Black",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/Icon_Outline/LampTwist_IconOutline_Black_HD.eps",
            "size": 2600122,
            "name": "LampTwist_IconOutline_Black_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/Icon_Outline/LampTwist_IconOutline_Black_HD.pdf",
            "size": 371985,
            "name": "LampTwist_IconOutline_Black_HD.pdf"
          }
        ]
      },
      {
        "variant": "Green",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/Icon_Outline/LampTwist_IconOutline_Green_HD.eps",
            "size": 2592846,
            "name": "LampTwist_IconOutline_Green_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/Icon_Outline/LampTwist_IconOutline_Green_HD.pdf",
            "size": 374203,
            "name": "LampTwist_IconOutline_Green_HD.pdf"
          }
        ]
      },
      {
        "variant": "White",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/Icon_Outline/LampTwist_IconOutline_White_HD.eps",
            "size": 2587106,
            "name": "LampTwist_IconOutline_White_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/Icon_Outline/LampTwist_IconOutline_White_HD.pdf",
            "size": 356119,
            "name": "LampTwist_IconOutline_White_HD.pdf"
          }
        ]
      },
      {
        "variant": "Yellow",
        "files": [
          {
            "ext": "EPS",
            "url": "/brand-assets/logo/HD_Print/Icon_Outline/LampTwist_IconOutline_Yellow_HD.eps",
            "size": 2604226,
            "name": "LampTwist_IconOutline_Yellow_HD.eps"
          },
          {
            "ext": "PDF",
            "url": "/brand-assets/logo/HD_Print/Icon_Outline/LampTwist_IconOutline_Yellow_HD.pdf",
            "size": 375015,
            "name": "LampTwist_IconOutline_Yellow_HD.pdf"
          }
        ]
      }
    ]
  },
  {
    "folder": "LD_Digital",
    "sub": "FullLogo",
    "variants": [
      {
        "variant": "Black",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_Black_LD.jpg",
            "size": 785536,
            "name": "LampTwist_FullLogo_Black_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_Black_LD.png",
            "size": 27315,
            "name": "LampTwist_FullLogo_Black_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_Black_LD.svg",
            "size": 3338,
            "name": "LampTwist_FullLogo_Black_LD.svg"
          }
        ]
      },
      {
        "variant": "FullColor",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_FullColor_LD.jpg",
            "size": 767064,
            "name": "LampTwist_FullLogo_FullColor_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_FullColor_LD.png",
            "size": 27797,
            "name": "LampTwist_FullLogo_FullColor_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_FullColor_LD.svg",
            "size": 3572,
            "name": "LampTwist_FullLogo_FullColor_LD.svg"
          }
        ]
      },
      {
        "variant": "Green",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_Green_LD.jpg",
            "size": 775473,
            "name": "LampTwist_FullLogo_Green_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_Green_LD.png",
            "size": 27577,
            "name": "LampTwist_FullLogo_Green_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_Green_LD.svg",
            "size": 3525,
            "name": "LampTwist_FullLogo_Green_LD.svg"
          }
        ]
      },
      {
        "variant": "White",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_White_LD.jpg",
            "size": 668540,
            "name": "LampTwist_FullLogo_White_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_White_LD.png",
            "size": 25995,
            "name": "LampTwist_FullLogo_White_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/FullLogo/LampTwist_FullLogo_White_LD.svg",
            "size": 3522,
            "name": "LampTwist_FullLogo_White_LD.svg"
          }
        ]
      }
    ]
  },
  {
    "folder": "LD_Digital",
    "sub": "Icon",
    "variants": [
      {
        "variant": "Black",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_Black_LD.jpg",
            "size": 914945,
            "name": "LampTwist_Icon_Black_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_Black_LD.png",
            "size": 70604,
            "name": "LampTwist_Icon_Black_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_Black_LD.svg",
            "size": 1084,
            "name": "LampTwist_Icon_Black_LD.svg"
          }
        ]
      },
      {
        "variant": "Green",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_Green_LD.jpg",
            "size": 895234,
            "name": "LampTwist_Icon_Green_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_Green_LD.png",
            "size": 68696,
            "name": "LampTwist_Icon_Green_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_Green_LD.svg",
            "size": 1188,
            "name": "LampTwist_Icon_Green_LD.svg"
          }
        ]
      },
      {
        "variant": "White",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_White_LD.jpg",
            "size": 687996,
            "name": "LampTwist_Icon_White_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_White_LD.png",
            "size": 66779,
            "name": "LampTwist_Icon_White_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_White_LD.svg",
            "size": 1185,
            "name": "LampTwist_Icon_White_LD.svg"
          }
        ]
      },
      {
        "variant": "Yellow",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_Yellow_LD.jpg",
            "size": 855783,
            "name": "LampTwist_Icon_Yellow_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_Yellow_LD.png",
            "size": 68935,
            "name": "LampTwist_Icon_Yellow_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/Icon/LampTwist_Icon_Yellow_LD.svg",
            "size": 1188,
            "name": "LampTwist_Icon_Yellow_LD.svg"
          }
        ]
      }
    ]
  },
  {
    "folder": "LD_Digital",
    "sub": "Icon_Outline",
    "variants": [
      {
        "variant": "Black",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_Black_LD.jpg",
            "size": 896353,
            "name": "LampTwist_IconOutline_Black_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_Black_LD.png",
            "size": 89481,
            "name": "LampTwist_IconOutline_Black_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_Black_LD.svg",
            "size": 1878,
            "name": "LampTwist_IconOutline_Black_LD.svg"
          }
        ]
      },
      {
        "variant": "Green",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_Green_LD.jpg",
            "size": 988572,
            "name": "LampTwist_IconOutline_Green_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_Green_LD.png",
            "size": 134823,
            "name": "LampTwist_IconOutline_Green_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_Green_LD.svg",
            "size": 1919,
            "name": "LampTwist_IconOutline_Green_LD.svg"
          }
        ]
      },
      {
        "variant": "White",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_White_LD.jpg",
            "size": 688003,
            "name": "LampTwist_IconOutline_White_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_White_LD.png",
            "size": 82254,
            "name": "LampTwist_IconOutline_White_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_White_LD.svg",
            "size": 1828,
            "name": "LampTwist_IconOutline_White_LD.svg"
          }
        ]
      },
      {
        "variant": "Yellow",
        "files": [
          {
            "ext": "JPG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_Yellow_LD.jpg",
            "size": 918521,
            "name": "LampTwist_IconOutline_Yellow_LD.jpg"
          },
          {
            "ext": "PNG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_Yellow_LD.png",
            "size": 86024,
            "name": "LampTwist_IconOutline_Yellow_LD.png"
          },
          {
            "ext": "SVG",
            "url": "/brand-assets/logo/LD_Digital/Icon_Outline/LampTwist_IconOutline_Yellow_LD.svg",
            "size": 1831,
            "name": "LampTwist_IconOutline_Yellow_LD.svg"
          }
        ]
      }
    ]
  }
];
